import {
  useAddBinderPage,
  useClearBinderSlot,
  useMoveBinderSlot,
  useRemoveBinderPage,
  useSetBinderSlot,
} from '@/hooks/binders/useBinders'
import type { Binder } from '@/types'

type SlotMove = {
  fromPageNumber: number
  fromPosition: number
  toPageNumber: number
  toPosition: number
}

/** Slot and page handlers for a loaded binder, with `binder.id` already bound in. */
export function useBinderSlotActions(binder: Binder | undefined) {
  const setSlot = useSetBinderSlot()
  const clearSlot = useClearBinderSlot()
  const moveSlot = useMoveBinderSlot()
  const addPage = useAddBinderPage()
  const removePage = useRemoveBinderPage()

  return {
    setSlot: (pageNumber: number, position: number, cardId: number) => {
      if (!binder) return
      setSlot.mutate({ id: binder.id, pageNumber, position, cardId })
    },
    clearSlot: (pageNumber: number, position: number) => {
      if (!binder) return
      clearSlot.mutate({ id: binder.id, pageNumber, position })
    },
    moveSlot: (args: SlotMove) => {
      if (!binder) return
      moveSlot.mutate({ id: binder.id, args })
    },
    addPage: (opts?: { onAdded?: (pageNumber: number) => void }) => {
      if (!binder) return
      addPage.mutate(binder.id, {
        onSuccess: (resp) => opts?.onAdded?.(resp.page.pageNumber),
      })
    },
    removePage: (pageNumber: number) => {
      if (!binder) return
      removePage.mutate({ id: binder.id, pageNumber })
    },
  }
}
